import "../styles.css";
import Pin from "./pin";
import Note from "./note";
import { useNotes } from "../context";
import { Toaster } from "react-hot-toast";

export default function Home() {
  const { notes } = useNotes();
  const checkPinNotes = (note) => {
    return note.pin === true;
  };
  const showPinNotes = notes.filter(checkPinNotes);
  return (
    <div className="home">
      {notes < 1 ? (
        <p className="p3 bold center">
          There is no task in present. Please add some task from Add New Task.
        </p>
      ) : (
        <>
          {showPinNotes.length > 0 ? (
            <>
              <Pin />
              <Note />
            </>
          ) : (
            <>
              <Note />
            </>
          )}
        </>
      )}
      <Toaster position="bottom-right" reverseOrder={true} />
    </div>
  );
}
